import Image from 'next/image';
import { Images } from '@/assets/imgs';
import VanillaTilt from 'vanilla-tilt';

import { CardData } from '@/constants';
import { useEffect, useRef } from 'react';

export const Beliefs = () => {
  return (
    <div className="about-container">
      <div className="layout-image">
        <Image
          src={Images.about.spheres}
          width={80}
          height={108}
          alt="layout-image1"
        />
      </div>

      <div className="container content">
        <h1>Our beliefs</h1>
        <div className="cards-container">
          {CardData?.map((cardData, index: number) => (
            <ImageComponent
              key={index}
              img={Images.about[cardData?.icon]}
              title={cardData?.title}
              description={cardData?.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

const ImageComponent = ({
  img,
  title,
  description,
}: {
  img: any;
  title?: string;
  description?: string;
}) => {
  const activeRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (activeRef.current)
      VanillaTilt.init(activeRef.current, {
        max: 0.01,
        scale: 1,
        glare: true,
        'max-glare': 1.5,
      });
  }, []);

  return (
    <div className="card">
      <div className="card-image" ref={activeRef}>
        <Image src={img} alt="" width={78} height={98} />
      </div>
      <div className="content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};
